/** Ids as stored, normalised to strings. `releaseIds` is optional on an idea and absent on most. */
export const normalizeReleaseIds = (ids: unknown): string[] =>
  Array.isArray(ids) ? ids.filter(Boolean).map(String) : [];

/** The linked delivery item's own set, whichever shape the idea arrived in. */
export const resolveLinkedProductItemReleaseIds = (idea: any): string[] =>
  normalizeReleaseIds(
    idea?.productItem?.releaseIds ?? idea?.linkedProductItem?.releaseIds
  );

/**
 * A digest to key local selection state on, rather than the array holding the ids. A
 * parent re-render that hands back an equal-but-newly-allocated array must not re-seed
 * over a save the server has already accepted.
 */
export const releaseIdsKey = (ids: unknown): string =>
  normalizeReleaseIds(ids).join("|");

export const releaseIdsFromKey = (key: string): string[] =>
  key ? key.split("|") : [];

const lower = (id: string) => String(id).toLowerCase();

/**
 * The union, idea's own first, deduplicated by id. A release tagged on both the idea and
 * its delivery item is one chip, not two — the two sets are separate records, not
 * separate things.
 */
export const unionReleaseIds = (ownIds: string[], linkedIds: string[]): string[] => {
  const seen = new Set(ownIds.map(lower));
  return [...ownIds, ...linkedIds.filter((id) => !seen.has(lower(id)))];
};

/** Only those the delivery item contributes — what the idea itself cannot edit. */
export const deliveryOnlyReleaseIds = (
  ownIds: string[],
  linkedIds: string[]
): string[] => {
  const own = new Set(ownIds.map(lower));
  return linkedIds.filter((id) => !own.has(lower(id)));
};
